import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import InsertForm from '../forms/insert-form';
import { insertValidationSchema } from '../schema/insert.js';

export default function InsertNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Insert Node Details',
        altText: 'Insert Node',
        defaultLabel: data?.command || 'Insert Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={InsertForm} schemaResolver={insertValidationSchema} />
    </NodeProvider>
  );
}
